/*
 * 计划与报告模块接口
 */

import { post, get, put, del } from 'api/http'

export default {
    // 设备点检合同列表
    getContractList(data) {
        // return get('/app/device_inspect/contract', data)
        return post('/wx/device/findDeviceInspectContractList', data, 'javaHost')
    },

    // 设备点检列表
    getDeviceCheckList(data) {
        // return get('/app/device_inspect/plan', data)
        return get('/wx/device/findDeviceInspectPlanDetail', data, 'javaHost')
    },

    // 设备点检-系统列表
    getSystemList(data) {
        // return get('/app/device_inspect/system', data)
        return get('/wx/device/findDeviceInspectPlanSysInfoList', data, 'javaHost')
    },

    // 设备点检-系统项
    getSystemItemList(data) {
        // return get('/app/device_inspect', data)
        return post('/wx/device/findCustomerSysDeviceList', data, 'javaHost')
    },

    // 设备点检-系统项详情
    getSystemItemDetail(data) {
        // return get('/app/device_inspect', data)
        return get('/wx/device/findDeviceInspectDetail', data, 'javaHost')
    },

    // 设备点检-修改系统项
    updateSystemItem(data) {
        // return put('/app/device_inspect', data)
        return post('/wx/device/editDeviceInspect', data, 'javaHost')
    },

    // 设备点检-修改系统项
    createCheck(data) {
        return post('/wx/device/addDeviceInspect', data, 'javaHost')
    },

    // 设备点检-在线报告详情
    getOnlineReportDetail(data) {
        // return get('/app/online_report', data)
        return get('/onlineReport/getDetails', data, 'javaHost')
    },

    // 设备点检-修改在线报告
    updateOnlineReport(data) {
        // return put('/app/online_report', data)
        return post('/onlineReport/edit', data, 'javaHost')
    },

    // 设备点检-测试结果
    saveTestResult(data) {
        // return put('/app/online_report', data)
        return post('/onlineReport/edit', data, 'javaHost')
    },

    // 设备点检-测试打印记录
    savePrintLog(data) {
        // return put('/app/online_report', data)
        return post('/onlineReport/edit', data, 'javaHost')
    },

    // 设备点检-用章签收
    saveStampedReceipt(data) {
        // return put('/app/online_report', data)
        return post('/onlineReport/edit', data, 'javaHost')
    },

    // 设备点检-日志
    getLog(data) {
        // return get('/app/online_report/logging', data)
        return get('/workflow/getWorkflowLogging', data, 'javaHost')
    },

    // 设备点检-生成报告
    createReport(data) {
        // return post('/app/online_report/generate', data)
        return get('/onlineReport/editOnlineReportWord', data, 'javaHost')
    },

    // 在线报告-二维码扫码页面
    getReportMsg(data) {
        return get('/app/online_report/qr_detail', data)
        // return get('/onlineReport/findQrDetail', data, 'javaHost')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/onlineTest.js